import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import API from '../../common/services/api.config.json';

@Injectable({
    providedIn: 'root'
})
export class DespachoService {
    constructor(private apiService: ApiService) { }

    GetAllCoordinatorsList(): Observable<RestResponse> {
        return this.apiService.get(API.Coordinator.getAllCoordinatorsList)
            .pipe(
                map(response => response),
                catchError(this.handleError)
            );
    }

    public GetDoctorListCoordinator(coordinador: string, year: string): Observable<RestResponse> {
        if (!coordinador) {
            return throwError(() => new Error('Nombre de coordinador no valido'));
        }

        const url = API.Coordinator.getCoordinatorDespachoColaboradoresDoctorList
            .replace('{coordinador}', encodeURIComponent(coordinador))
            .replace('{year}', year);

        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetDoctorVisitDetails(id: string): Observable<RestResponse> {
        const url = API.Coordinator.getDoctorVisit.replace('{id}', id);
        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetDoctorVisitWordReport(id: string): Observable<RestResponse> {
        const url = API.Coordinator.getDoctorVisitWordReport.replace('{id}', id);
        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetDoctorVisitWordReportByRange(body: any): Observable<RestResponse> {
        return this.apiService.post(API.Coordinator.getDoctorVisitWordReportByRange, body)
            .pipe(catchError(this.handleError));
    }

    public getEmpresasVisitaList(coordinador: string, year: string): Observable<RestResponse> {
        if (!coordinador) {
            return throwError(() => new Error('Nombre de coordinador no valido'));
        }

        const url = API.Coordinator.getEmpresasVisitaList
            .replace('{coordinador}', encodeURIComponent(coordinador))
            .replace('{year}', year);

        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetVisitaEmpresaDetails(id: string): Observable<RestResponse> {
        const url = API.Coordinator.getVisitaEmpresa.replace('{id}', id);
        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetVisitaEmpresaExcelReport(coordinador: string, year: string): Observable<RestResponse> {
        const url = API.Coordinator.getVisitaEmpresaExcelReport
            .replace('{coordinador}', encodeURIComponent(coordinador))
            .replace('{year}', year);

        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetVisitaEmpresaWordReport(id: string): Observable<RestResponse> {
        const url = API.Coordinator.getVisitaEmpresaWordReport.replace('{id}', id);
        return this.apiService.get(url).pipe(catchError(this.handleError));
    }

    public GetVisitaEmpresaWordReportByRange(body: any): Observable<RestResponse> {
        return this.apiService.post(API.Coordinator.getVisitaEmpresaWordReportByRange, body)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: any) {
        const errorMessage = error?.error instanceof ErrorEvent
            ? `Error: ${error.error.message}`
            : `Codigo: ${error?.status}, Mensaje: ${error?.message || error?.statusText}`;

        console.error(errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}
